import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=3dc83b6c"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"
import style0 from "./Title.vue?vue&type=style&index=0&id=3dc83b6c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports